export class CancelledError extends Error {}

export function createDebouncer<T>(fn: () => Promise<T | null>) {
	let timer: ReturnType<typeof setTimeout> | null = null;
	let reject: (() => void) | null = null;

	return async (debounceMs: number) => {
		if (timer != null) {
			clearTimeout(timer);
			timer = null;
		}

		if (reject != null) {
			reject();
			reject = null;
		}

		const wait = new Promise<void>((res, rej) => {
			reject = () => rej(new CancelledError("Canceled"));
			timer = setTimeout(() => {
				reject = null;
				timer = null;
				res();
			}, debounceMs);
		});

		try {
			await wait;
		} catch {
			return null;
		}

		return await fn();
	};
}
